var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"stream"}},_vm._l((_vm.postArray),function(project,index){return _c('GridItemContainer',{key:project.id,attrs:{"project":project,"index":index},on:{"update:project":function($event){project=$event}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }